const fontFamily = {
  theme: ['var(--theme-font)'],
  serif: ['var(--theme-font)'],
  sans: ['var(--theme-font)'],
}

const colors = {
  brand: '#ED1062',
  favorites: '#ED1062',
  // action colors:
  primary: {
    400: 'var(--theme-color-accent)',
    DEFAULT: 'var(--theme-color-accent)',
  },
  secondary: {
    100: '#F2F6FF',
    200: '#9FAAC0',
    300: '#5B6882',
    400: '#273043',
    500: '#000F2E',
    DEFAULT: '#273043',
  },
  tertiary: {
    100: '#FFDBDD',
    200: '#F38F95',
    300: '#E84954',
    400: '#DC0A18',
    500: '#B3000C',
    DEFAULT: '#DC0A18',
  },
  text: {
    100: '#FFFFFF',
    button: '#FFFFFF',
    200: '#BFBDBE',
    inactive: '#BFBDBE',
    300: '#918F90',
    ph: '#918F90',
    400: '#626162',
    label: '#626162',
    500: '#343333',
    body: '#343333',
    600: '#050505',
    heading: '#050505',
  },
  surface: {
    100: '#FCFDFF',
    200: '#FAFBFD',
    300: '#F8F9FB',
    400: '#F6F7F9',
    500: '#F4F5F7',
    600: '#EBEDF0',
    700: '#D8D9DB',
  },
  // accent colors:
  alert: {
    100: '#FFF2F2',
    200: '#F2C8C6',
    300: '#E6A19E',
    400: '#D97E79',
    DEFAULT: '#D97E79',
  },
  danger: {
    100: '#FFF2F2',
    200: '#F2C8C6',
    300: '#E6A19E',
    400: '#D97E79',
    DEFAULT: '#D97E79',
  },
  warning: {
    100: '#FFFCF2',
    200: '#F2E8C6',
    300: '#E6D59E',
    400: '#D9C279',
    DEFAULT: '#D9C279',
  },
  success: {
    100: '#F2FFF3',
    200: '#C6F2CA',
    300: '#9EE6A4',
    400: '#79D981',
    DEFAULT: '#79D981',
  },
  info: {
    100: '#F2F9FF',
    200: '#C6DEF2',
    300: '#9EC4E6',
    400: '#79ACD9',
    DEFAULT: '#79ACD9',
  },
  utility: {
    100: '#EEEAFA',
    200: '#DEC6F2',
    300: '#C59EE6',
    400: '#AE79D9',
    DEFAULT: '#AE79D9',
  },
  schedule: {
    yellow: '#F2DE24',
  },
}

const boxShadow = {
  'none': '0 0 #0000',
  'sm': 'var(--un-shadow-inset) 0px 2px 4px rgba(23, 32, 78, 0.08)',
  'md': 'var(--un-shadow-inset) 0px 4px 8px rgba(23, 32, 78, 0.08)',
  'lg': 'var(--un-shadow-inset) 0px 8px 16px rgba(23, 32, 78, 0.08)',
  'xl': 'var(--un-shadow-inset) 0px 16px 32px rgba(23, 32, 78, 0.08)',
  'inner': 'inset 0 2px 4px 0 rgba(0,0,0,0.05)',
  'btn-active': '0px 2px 4px rgba(23, 32, 78, 0.08)',
  'DEFAULT': 'var(--un-shadow-inset) 0px 4px 8px rgba(23, 32, 78, 0.08)',
}

// const breakpoints = {
//   // bootstrap breakpoints
//   'xs': '319.75px',
//   'sm': '575.75px',
//   'md': '767.75px',
//   'lg': '991.75px',
//   'xl': '1199.75px',
//   'xxl': '1399.75px',
//   '2xl': '1399.75px',
// }

const bootstrapBreakpoints = {
  'xs': 319.75,
  'sm': 575.75,
  'md': 767.75,
  'lg': 991.75,
  'xl': 1199.75,
  'xxl': 1399.75,
  '2xl': 1399.75,
}

const breakpointsJs = bootstrapBreakpoints

const breakpointsCss = Object.entries(breakpointsJs).reduce(
  (obj = {}, [key, value]) => {
    obj[key] = `${value}px`
    return obj
  },
  {},
)

const containerBreakpoints = {
  name: 'main',
  // bootstrap breakpoints - 250px for sidebar
  breakpoints: {
    'xs': '0px',
    'sm': '326.75px',
    'md': '517.75px',
    'lg': '741.75px',
    'xl': '949.75px',
    'xxl': '1149.75px',
    '2xl': '1149.75px',
  },
}

const zIndex = {
  'floating': '10',
  'sticky': '100',
  'fixed': '1000',
  'fixed+1': '1001',
  'modal-backdrop': '10000',
  'modal': '10001',
  'offcanvas-backdrop': '100000',
  'offcanvas': '100001',
  'toast': '1000000',
}

const theme = {
  fontFamily,
  colors,
  breakpoints: breakpointsCss,
  containerBreakpoints,
  boxShadow,
  zIndex,
}

export { fontFamily, colors, breakpointsJs, breakpointsCss, containerBreakpoints, boxShadow, zIndex }
export default theme
